import { Module} from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { DownTimeTracking } from "./dto/downtime-tracking.entity";
import { DownTimeTrackingService } from "./downtime-tracking.service";
import { DowntimeTrackingController } from "./downtime-tracking.controller";
import { DownTimeTrackingAdapter } from "./dto/downtime-tracking.adapter";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import { ForkLiftJobService } from "@gtpl/shared-services/warehouse-management";
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { LogsService } from "@gtpl/shared-services/user-logs";


@Module({
    imports:[TypeOrmModule.forFeature([DownTimeTracking]),

],
controllers:[DowntimeTrackingController],
providers:[DownTimeTrackingService,DownTimeTrackingAdapter,ApplicationExceptionHandler,WhatsAppNotificationService,ForkLiftJobService,WhatsappBroadCastService,LogsService],
exports:[],

})

export class DownTimeTrackingModule{}

